import script from "./LoadingComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoadingComponent.vue?vue&type=script&setup=true&lang=ts"

import "./LoadingComponent.vue?vue&type=style&index=0&id=45d40b80&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45d40b80"]])

export default __exports__